import { colors } from '@material-ui/core';

export default {
  contained: {
    '&:hover': {
      backgroundColor: colors.grey[300]
    },
    backgroundColor: colors.grey[100],
    boxShadow: '0 1px 1px 0 rgba(0,0,0,0.14)',
  },
};
